module.exports = __webpack_public_path__ + "img/batubara-mini.0fed0baa.png";